var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZipcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zipcode",
    transform: "translate(-176.787 -4.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1300",
    "data-name": "Ellipse 1300",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(176.787 4.011)",
    fill: "#39be9d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34412",
    "data-name": "Path 34412",
    d: "M262.035,83.067a3.328,3.328,0,1,0-3.328,3.3A3.319,3.319,0,0,0,262.035,83.067Zm-5.746,0a2.419,2.419,0,1,1,2.418,2.393A2.408,2.408,0,0,1,256.288,83.067Z",
    transform: "translate(-67.144 -68.265)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34413",
    "data-name": "Path 34413",
    d: "M191.562,26.793a.455.455,0,0,0,.353-.168c.221-.273,5.423-6.75,5.423-11.886a5.776,5.776,0,0,0-11.552,0c0,5.136,5.2,11.613,5.422,11.886A.455.455,0,0,0,191.562,26.793Zm0-16.873a4.848,4.848,0,0,1,4.867,4.818c0,4.069-3.693,9.3-4.867,10.856-1.174-1.559-4.866-6.787-4.866-10.856a4.848,4.848,0,0,1,4.866-4.818Z",
    transform: "translate(0 0)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34414",
    "data-name": "Path 34414",
    d: "M207.669,525.14h-9.827a.454.454,0,1,0,0,.909h9.827a.454.454,0,0,0,0-.909Z",
    transform: "translate(-11.193 -496.976)",
    fill: "#39be9d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipcode);
export default __webpack_public_path__ + "static/media/Zipcode.a78dcbcdca018c73b24a9294cfc51c77.svg";
export { ForwardRef as ReactComponent };